import { render, staticRenderFns } from "./BButtonUploadFile.vue?vue&type=template&id=0faab37c&scoped=true&"
import script from "./BButtonUploadFile.vue?vue&type=script&lang=js&"
export * from "./BButtonUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./BButtonUploadFile.vue?vue&type=style&index=0&id=0faab37c&lang=scss&scoped=true&"
import style1 from "./BButtonUploadFile.vue?vue&type=style&index=1&lang=css&"
import style2 from "./BButtonUploadFile.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faab37c",
  null
  
)

export default component.exports